import { createSlice } from '@reduxjs/toolkit';
import { getActiveUsers } from './activeUsersAction';

const activeUsersSlice = createSlice({
  name: 'activeUsers',
  initialState: {
    loading: false,
    error: null,
    dayObject: {},
    weekObject: {},
    monthObject: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getActiveUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getActiveUsers.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.dayObject = payload.dayObject;
      state.weekObject = payload.weekObject;
      state.monthObject = payload.monthObject;
    });
    builder.addCase(getActiveUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export { activeUsersSlice };
